import React, { PropTypes, Component } from 'react';
import {
    launchLogin as oneIdLaunchLogin,
    on as oneIdOn
} from 'lib/oneId';

class MainContainer extends Component {
    componentDidMount() {
        const { showLogin } = this.props;
        // navigating between routes could have potentially wiped away espn_ui's reference to the main-container
        // this reinitializes that container after re-render
        if (window.espn_ui && window.espn_ui.Helpers && window.espn_ui.Helpers.page && window.jQuery) {
            window.espn_ui.Helpers.page.container = window.jQuery('#main-container');
        }

        if (showLogin) {
            try {
                oneIdOn('login', () => {
                    /**
                     * trigger page reload so that oneId login state will be refreshed
                     * and user can see playback after logging in
                     */
                    window.location.reload();
                });
                oneIdLaunchLogin();
            } catch (err) {
                console.error(`Show login error: ${err}`);
            }
        }
    }

    render() {
        return (
            <div className={this.props.className}>
                {this.props.pre}
                <section id="main-container">
                    <div className="main-content layout-dbc">
                        {this.props.children}
                    </div>
                </section>
            </div>
        );
    }
}

MainContainer.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    pre: PropTypes.array,
    showLogin: PropTypes.bool
};

export default MainContainer;



// WEBPACK FOOTER //
// ./app/common/page/common/MainContainer.js